const minutesInSeconds = (minutes) => {
  return minutes * 60;
};

const hoursInSeconds = (hours) => {
  return hours * minutesInSeconds(60);
};

export const EXPIRATION_VALUES = [
  { name: "1 minuto", value: minutesInSeconds(1) },
  { name: "2 minutos", value: minutesInSeconds(2) },
  { name: "3 minutos", value: minutesInSeconds(3) },
  { name: "4 minutos", value: minutesInSeconds(4) },
  { name: "5 minutos", value: minutesInSeconds(5) },
  { name: "6 minutos", value: minutesInSeconds(6) },
  { name: "7 minutos", value: minutesInSeconds(7) },
  { name: "8 minutos", value: minutesInSeconds(8) },
  { name: "9 minutos", value: minutesInSeconds(9) },
  { name: "10 minutos", value: minutesInSeconds(10) },
  { name: "15 minutos", value: minutesInSeconds(15) },
  { name: "20 minutos", value: minutesInSeconds(20) },
  { name: "30 minutos", value: minutesInSeconds(30) },
  { name: "45 minutos", value: minutesInSeconds(45) },
  { name: "1 hora", value: hoursInSeconds(1) },
  { name: "2 horas", value: hoursInSeconds(2) },
  { name: "3 horas", value: hoursInSeconds(3) },
  { name: "4 horas", value: hoursInSeconds(4) },
  { name: "5 horas", value: hoursInSeconds(5) },
  { name: "6 horas", value: hoursInSeconds(6) },
  { name: "7 horas", value: hoursInSeconds(7) },
  { name: "8 horas", value: hoursInSeconds(8) },
  { name: "9 horas", value: hoursInSeconds(9) },
  { name: "10 horas", value: hoursInSeconds(10) },
  { name: "11 horas", value: hoursInSeconds(11) },
  { name: "12 horas", value: hoursInSeconds(12) },
];
